import {
  queryXcxItemByActId,
  recommend,
  queryCouponList,
  receiveCoupon,
  getPurchaseRecord,
  getSalesInfo,
  getShareURL,
  lottry,
  getActivityInfos,
  batchQueryCanReceiveCouponApi,
  getAppShareURL,
  chainsInfoApi,
  chainsPublishApi,
  queryXcxNoPubItemByActIdApi,
  qryYlxdSqSelfPickupSitesApi,
  qryXcxItemPubCatByActIdApi,
  findXcxItemPubByConditionApi,
} from "@/libs/api.js";
import { getShareInfo } from "@/libs/wxShare.js";
import dragMixins from "@/mixins/dragAble";
import customVideo from "@/components/video.vue";
import couponItem from "@/components/couponItem.vue";
import constants from "vant/lib/sku/constants";
import bottomPop from "@/components/ylsq/bottomPop.vue";
import shareButton from "@/components/ylsq/shareButton.vue";
export default {
  name: "chainsDetail",
  components: { customVideo, couponItem, bottomPop, shareButton },
  mixins: [dragMixins],
  data() {
    return {
      shopNumber: 0,
      isPilot: false,
      uleUrl: "",
      isActive: false,
      chainsDetail: [], // 接龙活动图片与描述
      chainsList: [], // 接龙活动商品
      activityFlag: "", //接龙活动类型  1为套餐活动
      freshActType: "", //是否试点城市  ''  否  1  是
      setMealNum: 1, //套餐数量
      orderList: [], // 购买成功订单列表
      videoUrl: "", // 接龙活动视频地址
      isOver: false, // 接龙活动是否过期
      videoWith: 0, //视频宽度
      videoImg: "", // 视频封面
      transport: "",
      activityId: "",
      selfSite: "",
      buttonText: "我要接龙",
      query: {
        activityCode: "",
        pageIndex: 1,
        pageSize: 30,
      },
      shareId: this.getStorage("user", "user.STORE_ID"),
      client_type: "wap_ylxdsq",
      store_id: "",
      subList: [],
      isYlxdsqApp: false,
      shareName: "",
      activityStartTime: "",
      activityEndTime: "",
      lastTime: "",
      isShowItemImg: false,
      currentPopImg: "",
      defaultAvatar: "https://i0.ulecdn.com/i/my/120928/avatar29.png",
      isShowCoupon: false,
      prizeMoney: "", // 优惠券金额
      fullcutAmountLimit: "", // 优惠门槛
      couponList: [],
      totalCount: "",
      loading: false,
      finished: false,
      finishedText: "",
      isHnApp: false,
      isShowCouponPop: false,
      oldCouObj: [],
      couponActivity: "chains_activity_code", //推荐额编码
      tipsQualification: "",
      couponTypes: {
        "1": "店铺券",
        "2": "商品券",
        "3": "运费券",
        "4": "充值券",
        "5": "全场券",
        "6": "品类券",
      },
      couponListData: [],
      nowTime: new Date().getTime(),
      isFixed: true, //按钮是否固定定位
      timeData: "",
      groupNum: "",
      buyerCount: "",
      productNumTotal: "",
      moreText: "点击查看更多商品介绍",
      showMore: false,
      totalNumber: null,
      union_id: "",
      union_ref: "",
      noData: false,
      isBegin: false,
      isCheck: "0",
      isShowBottom: false,
      isShowMiddle: false,
      shareImg: "",
      currentState: null, // 当前活动状态
      id: null,
      userid: null,
      isSite: 0, // 是否有自提点 0-初始化 1-有 2-无
      isShowRightTitle: true, // 右侧二级分类是否显示
      rightNavList: [],
      categoryNavShow: false,
      boxHeight: 0,
      leftNavList: [],
      active: 0,
      isLoad: false,
      cateQuery: {
        activityId: "",
        pageIndex: 1,
        pageSize: 500,
        itemName: "",
        categoryId: "",
      },
      cont: [],
      cateFinished: false,
      cateLoading: false,
      cateFinishedText: "",
      selected: {
        categoryId: "",
        subCateId: "",
      },
      currentNav: "", // 右侧顶部选中
      cateTotalNumber: null,
      cateSelectList: [],
      zdAct:['p1381199','p1386440','p1152762','p1152763','p1385398','p1389677', 'p1393146','p1397177','p1404216'],
    };
  },
  created() {
    // window.addEventListener("resize", this.resizeEvent, true);
    // window.addEventListener("scroll", this.scrollEvent, true);
  },
  async mounted() {
    let _this = this;
    if (_this.$browser().ylxdsq || _this.$browser().ulemax) {
      if (_this.$route.query.status == 1) {
        window.dsBridge.call("setNativeTitle", {
          title: "修改拼团接龙",
        });
      } else {
        window.dsBridge.call("setNativeTitle", {
          title: "拼团接龙",
        });
      }
    }
    this.isCheck = this.$route.query.isCheck || "0";
    this.union_id = this.$route.query.union_id || "";
    this.union_ref = this.$route.query.union_ref || "";
    if (this.$browser().ule || this.$browser().ylxd) {
      window.dsBridge &&
        window.dsBridge.call("setNativeTitle", {
          title: "接龙活动",
        });
    }
    if (this.$browser().ylxdsq || this.$browser().ulemax) {
      this.callPilotStatus();

      window.dsBridge &&
        window.dsBridge.call("setNativeTitle", {
          title: "接龙活动",
        });
      this.isSite = await this.getUserInfo();
      console.log("isSite", this.isSite);
    }
    // this.isSite = await this.getUserInfo();
    // console.log("isSite", this.isSite);
    this.isHnApp = navigator.userAgent.indexOf("chinapostHuiNong") > -1 ? true : false;
    this.activityId = this.$route.params.activityId;
    this.cateActivityId = this.activityId.slice(2);
    this.freshActType = this.$route.query.freshActType || "";
    
    if (this.$route.query.buyingGroup && this.$route.query.buyingGroup == "true") {
      this.client_type = "app_huinong";
    } else this.client_type = this.$route.query.ul_sch || this.$route.query.client_type || this.$cookies.get("ul_sch") || this.$cookies.get("client_type");

    if (this.client_type == "app_huinong") {
      document.cookie = `ul_sch=app_huinong;domain=.${this.$uleUrl()};path=/;expires=3600`;
      document.title = "社区团购";
    } else {
      document.title = "邮乐优鲜";
    }
    // 优鲜app
    if (this.$browser().ylxdsq || this.$browser().ulemax || this.$browser().zyet || (this.isHnApp && !(this.$route.query.buyingGroup && this.$route.query.buyingGroup == "true"))) {
      this.isYlxdsqApp = true;
      this.buttonText = "立即分享";
    }
    this.uleUrl = this.$uleUrl();
    this.store_id = this.$route.query.store_id || this.$route.query.storeid || "";
    this.shareId = this.$route.query.shareId || this.$route.query.share_id || "";
    // this.resizeEvent();
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("resize", this.resizeEvent);
    });
    this.$toast.loading({
      duration: 0,
      mask: true,
      message: "加载中...",
    });
    if (this.zdAct.includes(this.$route.params.activityId)) {
      console.log('不请求优惠券');
    } else {
      this.getCouponList();
    }
    this.getGoodsDetail(this.$route.params.activityId);
    let params = {
      actCode: this.$route.params.activityId || "",
    };
    this.getNumber(params);
    // this.getOrderList(this.$route.params.activityId);
  },
  computed: {
    // 合计
    total() {
      let num = 0;
      this.totalNumber = null;
      this.chainsList.forEach((element) => {
        if (element.number > 0) {
          num += element.number * element.salPrice;
          if (this.activityFlag == 1) {
            this.totalNumber += Number(element.limitNum);
          } else {
            this.totalNumber += Number(element.number);
          }
        }
      });
      return num;
    },
  },
  methods: {
    getCouponList() {
      //获取优惠券信息
      recommend({
        sectionKeys: this.couponActivity,
        time: new Date().getTime(),
      }).then((res) => {
        if (res.chains_activity_code) {
          let data = res.chains_activity_code[0].customAttribute;
          this.tipsQualification = data.tipsQualification;
          queryCouponList(data.activityCode).then((res) => {
            if (res.code == "0000") {
              this.couponListData = res.content.prizeCouponDetails;
            }
          });
        }
      });
    },
    getCoupon(coupon) {
      //领取优惠券
      coupon.received = false;
      let channels = {
        wap: "300000", //邮乐wap
        ule: "200000", //邮乐APP
        ulemp: "800001", //邮乐商城微信小程序
        uxd: "600000", //邮乐小店
        usq: "610002", //邮乐优鲜APP
        usqmp: "610001", //邮乐优鲜小程序
        usqh5: "610003", //邮乐优鲜H5
        yzgxd: "400006", //邮小店掌柜版APP
        ysh: "500004", //邮生活
      };
      let data = {
        activityCode: coupon.activityNo,
        couponDetailId: coupon.couponDetailId,
        channel: channels.usqh5,
      };
      if (this.$browser().miniprogram) {
        //小程序
        data.channel = channels.usqmp;
      } else if (this.$browser().ylxdsq || this.$browser().ulemax) {
        //优鲜APP
        data.channel = channels.usq;
      }
      receiveCoupon(data).then((res) => {
        if (res.code == "0000") {
          //领券成功
          coupon.received = true;
          this.$forceUpdate();
          this.$toast("领取成功");
          //神策埋点
          window.uleStatUtil &&
            window.uleStatUtil.sendSensorTrack("ylyx_CouponsReceive", {
              ylyx_coupon_code: coupon.couponDetailId,
              ylyx_coupon_type: "满减",
              ylyx_coupon_name: coupon.remark || "",
            });
        } else if (res.code == "10000") {
          //未登录/注册
          let currentLink = encodeURIComponent(`https://h5.${process.env.VUE_APP_HOST}/yxd/community${this.$route.fullPath}`); // 当前访问地址
          window.location.href = `https://m.${process.env.VUE_APP_HOST}/muser/user/login?target=${currentLink}`;
        } else if (res.code == "1003") {
          //没资格
          this.$toast(this.tipsQualification);
        } else if (res.code == "3003" || res.code == "3012") {
          //优惠券当日已领完   优惠券当前场已领完
          coupon.dayIsHaveStock = false;
          this.$toast(res.message);
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 获取接龙活动信息
    getGoodsDetail(activityId) {
      // 未发布
      if (this.$route.query.status == 1) {
        queryXcxNoPubItemByActIdApi(activityId)
          .then((res) => {
            if (res) {
              if (res.code === "0000") {
                this.$toast.clear();
                if (res.data) {
                  this.id = res.data.id;
                  this.currentState = res.data.activityState;
                  this.shareName = res.data.activityName;
                  this.activityStartTime = this.$moment(res.data.startTime).format("YYYY/MM/DD");
                  this.activityEndTime = this.$moment(res.data.endTime).format("YYYY/MM/DD");
                  this.lastTime = this.$moment(res.data.endTime).diff(this.$moment());
                  let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"); // 当前时间
                  let endDate = this.$moment(res.data.endTime).format("YYYYMMDDHHmmss");
                  let startDate = this.$moment(res.data.startTime).format("YYYYMMDDHHmmss");
                  if (currentDate < startDate) {
                    console.log("没有开始");
                    this.isBegin = false;
                  } else {
                    this.isBegin = true;
                  }
                  // 接龙活动状态
                  currentDate > endDate ? (this.isOver = true) : (this.isOver = false);
                  // 接龙活动信息
                  if (res.data.activityDesc) {
                    this.chainsDetail = JSON.parse(res.data.activityDesc) || [];
                  }
                  this.transport = res.data.transport;
                  this.activityFlag = res.data.activityFlag;
                  this.selfSite = res.data.selfSite;
                  this.groupNum = res.data.groupNum;
                  this.chainsDetail.forEach((item) => {
                    if (item.imgUrl) {
                      item.imgUrl = item.imgUrl.replace("http://", "https://");
                    }
                  });
                  this.videoUrl = res.data.videoUrl;
                  this.videoImg = res.data.shareImgUrl.replace("http://", "https://");
                  // 接龙商品列表
                  this.chainsList = res.data.xcxItemVOList;
                  // let salePriceList = [];
                  this.chainsList.forEach((item) => {
                    if (item.imgUrl) {
                      item.imgUrl = item.imgUrl.split("|*|")[0];
                      item.imgUrl = item.imgUrl.replace("http://", "https://");
                      item.imgLarge = item.imgUrl;
                      if (!/_l\.jpg/.test(item.imgUrl)) {
                        item.imgUrl = item.imgUrl.replace(".jpg", "_l.jpg");
                      }
                    }
                    item.number = 0;
                    item.limitNum = item.limitNum ? item.limitNum : 1;
                    item.totalSold = 0;
                  });
                  if (this.chainsList.length > 0) {
                    this.shareImg = this.chainsList[0].imgUrl;
                  }
                  this.chainsList = JSON.parse(JSON.stringify(this.chainsList));
                  this.shopNumber = this.chainsList.length || 0;
                  console.log("shopNumber", this.shopNumber);
                  if (this.shopNumber > 10) {
                    // 获取分类
                    qryXcxItemPubCatByActIdApi({ activityId: this.cateActivityId }).then((res) => {
                      this.overShow = false;
                      this.cont.push({ goods: [] });
                      res.data.forEach((item, index) => {
                        this.leftNavList.push({
                          text: item.name,
                          id: item.id,
                          children: [
                            {
                              id: item.id,
                              name: "全部",
                            },
                          ].concat(item.children),
                        });
                        if (this.selected.categoryId == item.id) {
                          this.active = index;
                        }
                      });
                      this.leftNavList.map((item, index) => {
                        if (item.id == this.$route.query.categoryId) {
                          this.active = index;
                        }
                      });
                      if (this.leftNavList.length > 0) {
                        this.rightNavList = this.leftNavList[this.active].children;
                      }
                      this.isShowRightTitle = true;
                      this.cateQuery.categoryId = this.selected.subCateId || this.leftNavList[this.active]["children"][0].id;
                      this.currentNav = this.selected.subCateId || this.leftNavList[this.active]["children"][0].id;
                      this.fetch();
                    });
                    // 获取页面中间高度
                    this.boxHeight = document.documentElement.clientHeight;
                    console.log("scrollview===", this.scrollview);
                  }
                  getSalesInfo(activityId).then((data) => {
                    if (data.code === "0000") {
                      this.chainsList.forEach((item) => {
                        data.data.forEach((ele, index) => {
                          if (item.listId === ele.listingId) {
                            item.totalSold = data.data[index].totalSold;
                          }
                        });
                      });
                    }
                  });
                  //微信且不是小程序  初始化微信分享信息
                  if ((this.$browser().wx || this.$browser().wxwork) && !this.$browser().miniprogram) {
                    this.share();
                  }
                  this.$nextTick(() => {
                    // this.scrollEvent()
                  });

                  if (this.$route.query.shareId) {
                    //神策埋点
                    let _this = this;
                    window.uleStatUtil &&
                      window.uleStatUtil.sendSensorTrack("ylxd_ShareClickSuccess", {
                        ylyx_shared_identify_key: "storeid", // 被分享用户  ID-key
                        ylyx_shared_identify_value: _this.$route.query.storeid || _this.$route.query.store_id || "", // 被分享用户 ID-value
                        // exp_id: exp_id,
                        ylyx_share_channel: "微信好友", // 分享渠道
                        ylyx_share_content_type: "接龙", // 分享内容类型
                        ylyx_share_content_name: _this.shareName, // 分享内容名称
                        item_id: activityId, // 物品id
                        ylxd_share_content_id: _this.$route.query.shareId, // 分享内容 ID
                      });
                  }
                  setTimeout(() => {
                    // 跳转至查看商品列表处
                    if (this.isCheck == "1") {
                      this.$nextTick(() => {
                        setTimeout(() => {
                          document.querySelector(".chains-list").scrollIntoView({
                            behavior: "smooth",
                          });
                        }, 100);
                      });
                    }
                  }, 500);
                } else {
                  this.noData = true;
                }
              } else {
                this.$toast.clear();
                this.noData = true;
              }
            } else {
              this.$toast.clear();
              this.$router.push("/others/pageList");
            }
          })
          .then(() => {
            let isQuery = true; //是否请求查券接口
            if (this.$route.params.activityId == "z178656" || this.$route.params.activityId == "z279452") {
              //z178656 邮政集团乡村振兴团购会（快递）   z279452 邮政集团乡村振兴团购会（自提）
              isQuery = false;
            }
            // 活动未结束-查询优惠券
            if (!this.isOver && isQuery) {
              // 查询优惠券
              let itemIdString = "";
              this.chainsList.forEach((item) => {
                itemIdString += `${item.itemId}:${item.categoryIdPath};`;
              });
              // 去掉最后一个分号
              itemIdString = itemIdString.slice(0, itemIdString.length - 1);
              let query = {
                itemList: itemIdString,
                businessType: "4",
                // userId: this.getStorage("user", "user.STORE_ID") || '',
                pageIndex: 1,
                pageSize: 100,
              };
              if (this.zdAct.includes(this.$route.params.activityId)) {
                console.log('不请求优惠券');
              } else {
                batchQueryCanReceiveCouponApi(query).then((res) => {
                  let data = {};
                  if (res.code == "0000") {
                    data = res.data;
                    if (data.length > 0) {
                      data.map((item) => {
                        let newObj = {
                          available: 1,
                          id: "", //优惠券 id
                          name: "", // 优惠券名称
                          condition: "", // 满减条件
                          description: "",
                          reason: "", // 不可用原因
                          value: null, // 折扣券优惠金额，单位分
                          startAt: null,
                          endAt: null,
                          valueDesc: "", // 折扣券优惠金额文案
                          unitDesc: "元", // 单位文案
                        };
                        switch (item.couponType) {
                          case "1":
                            item.type = "店铺券";
                            break;
                          case "2":
                            item.type = "商品券";
                            break;
                          case "3":
                            item.type = "运费券";
                            break;
                          case "4":
                            item.type = "充值券";
                            break;
                          case "5":
                            item.type = "通用券";
                            break;
                          case "6":
                            item.type = "品类券";
                            break;
                          case "7":
                            item.type = "跨店券";
                            break;
                          default:
                            item.type = "商品券";
                        }
                        if (item.isMultiStore == "true") {
                          item.type = "跨店券";
                        }
                        newObj.id = item.batchId;
                        newObj.name = item.remark || "优惠券名称";
                        newObj.description = item.type;
                        newObj.reason = "";
                        newObj.value = item.amount * 100;
                        newObj.startAt = this.$moment(item.expireBeginDate).format("X");
                        newObj.endAt = this.$moment(item.expireEndDate).format("X");
                        newObj.valueDesc = item.amount;
                        newObj.couponWallFlag = item.couponWallFlag;
                        item.couponName = item.type;
                        if (item.couponType == "7") {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          // newObj.condition = "全站满" + item.fullCutAmount + "减" + item.amount;
                          // item.desc = "全站满" + item.fullCutAmount + "减" + item.amount;
                        } else {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                        }
                        // arr.push(newObj);
                      });
                      this.oldCouObj = data;
                      this.isShowCouponPop = true;
                    } else {
                      this.isShowCouponPop = false;
                    }
                  } else {
                    this.isShowCouponPop = false;
                  }
                });
                let themeCode = "159523003875223";
                let userOnlyId = this.getStorage("user", "user.STORE_ID");
                let data = {
                  activityCode: "",
                  channel: "610003",
                  fieldId: "",
                  deviceId: "",
                  userOnlyId,
                };
                if (process.env.NODE_ENV === "development") {
                  themeCode = "159471246591743";
                } else if (process.env.NODE_ENV === "testing") {
                  themeCode = "159521105177522";
                } else if (process.env.NODE_ENV === "production") {
                  themeCode = "159523003875223";
                }
                // 是否登录
                if (userOnlyId) {
                  // 是否有场次
                  getActivityInfos(themeCode).then((dt) => {
                    if (dt.code === "0000") {
                      data.activityCode = dt.content[0].activityCode;
                      if (this.client_type === "miniwx_ylxdsq") {
                        data.channel = "610001";
                      }
                      lottry(data).then((rs) => {
                        if (rs.code === "0000") {
                          if (rs.content.prizeInfos.length > 0) {
                            this.isShowCoupon = true;
                            this.couponList = rs.content.prizeInfos;
                          }
                        } else {
                          this.isShowCoupon = false;
                        }
                      });
                    }
                  });
                }

              }
            } else {
              this.isShowCouponPop = false;
            }
          });
      }
      // 已发布
      else {
        queryXcxItemByActId(activityId)
          .then((res) => {
            if (res) {
              if (res.code === "0000") {
                this.$toast.clear();
                if (res.data) {
                  this.id = res.data.id;
                  this.currentState = res.data.activityState;
                  this.shareName = res.data.activityName;
                  this.activityStartTime = this.$moment(res.data.startTime).format("YYYY/MM/DD");
                  this.activityEndTime = this.$moment(res.data.endTime).format("YYYY/MM/DD");
                  this.lastTime = this.$moment(res.data.endTime).diff(this.$moment());
                  let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"); // 当前时间
                  let endDate = this.$moment(res.data.endTime).format("YYYYMMDDHHmmss");
                  let startDate = this.$moment(res.data.startTime).format("YYYYMMDDHHmmss");
                  if (currentDate < startDate) {
                    console.log("没有开始");
                    this.isBegin = false;
                  } else {
                    this.isBegin = true;
                  }
                  // 接龙活动状态
                  currentDate > endDate ? (this.isOver = true) : (this.isOver = false);
                  // 接龙活动信息
                  if (res.data.activityDesc) {
                    this.chainsDetail = JSON.parse(res.data.activityDesc) || [];
                  }
                  this.transport = res.data.transport;
                  this.activityFlag = res.data.activityFlag;
                  this.selfSite = res.data.selfSite;
                  this.groupNum = res.data.groupNum;
                  this.videoUrl = res.data.videoUrl;
                  this.videoImg = res.data.shareImgUrl.replace("http://", "https://");
                  // 接龙商品列表
                  this.chainsList = res.data.xcxItemVOList;
                  let salePriceList = [];
                  this.chainsList.forEach((item) => {
                    if (item.imgUrl) {
                      item.imgUrl = item.imgUrl.split("|*|")[0];
                      item.imgUrl = item.imgUrl.replace("http://", "https://");
                      item.imgLarge = item.imgUrl;
                      if (!/_l\.jpg/.test(item.imgUrl)) {
                        item.imgUrl = item.imgUrl.replace(".jpg", "_l.jpg");
                      }
                    }
                    item.number = 0;
                    item.limitNum = item.limitNum ? item.limitNum : 1;
                    item.totalSold = 0;
                    salePriceList.push(item.salPrice);
                    // 有自提点
                    if (this.isSite == 1) {
                      item.shareCommission > 0 ? (item.shareCommission = Number(item.shareCommission).toFixed(2)) : "0.00";
                      item.saleCommission > 0 ? (item.saleCommission = Number(item.saleCommission).toFixed(2)) : "0.00";
                    }
                    // 无自提
                    else if (this.isSite == 2) {
                      // item.totalCommission = (Number(item.yzgRealCommission) - Number(item.saleCommission || 0)).toFixed(2);
                      if (item.shareCommission > 0) {
                        item.totalCommission = item.shareCommission;
                      } else {
                        item.totalCommission = item.yzgRealCommission || 0;
                      }
                      console.log("totalCommission==", item.totalCommission);
                    }
                  });
                  if (this.chainsList.length > 0) {
                    this.shareImg = this.chainsList[0].imgUrl;
                  }
                  this.chainsList = JSON.parse(JSON.stringify(this.chainsList));
                  this.shopNumber = this.chainsList.length || 0;
                  console.log("shopNumber", this.shopNumber);
                  if (this.shopNumber > 10) {
                    // 获取分类
                    qryXcxItemPubCatByActIdApi({ activityId: this.cateActivityId }).then((res) => {
                      this.overShow = false;
                      this.cont.push({ goods: [] });
                      res.data.forEach((item, index) => {
                        this.leftNavList.push({
                          text: item.name,
                          id: item.id,
                          children: [
                            {
                              id: item.id,
                              name: "全部",
                            },
                          ].concat(item.children),
                        });
                        if (this.selected.categoryId == item.id) {
                          this.active = index;
                        }
                      });
                      this.leftNavList.map((item, index) => {
                        if (item.id == this.$route.query.categoryId) {
                          this.active = index;
                        }
                      });
                      if (this.leftNavList.length > 0) {
                        this.rightNavList = this.leftNavList[this.active].children;
                      }
                      this.isShowRightTitle = true;
                      this.cateQuery.categoryId = this.selected.subCateId || this.leftNavList[this.active]["children"][0].id;
                      this.currentNav = this.selected.subCateId || this.leftNavList[this.active]["children"][0].id;
                      this.fetch();
                    });
                    // 获取页面中间高度
                    this.boxHeight = document.documentElement.clientHeight;
                    console.log("scrollview===", this.scrollview);
                  }
                  getSalesInfo(activityId).then((data) => {
                    if (data.code === "0000") {
                      this.chainsList.forEach((item) => {
                        data.data.forEach((ele, index) => {
                          if (item.listId === ele.listingId) {
                            item.totalSold = data.data[index].totalSold;
                          }
                        });
                        // item.totalSold = data.data[index].totalSold;
                      });
                    }
                  });
                  //微信且不是小程序  初始化微信分享信息
                  if ((this.$browser().wx || this.$browser().wxwork) && !this.$browser().miniprogram) {
                    this.share();
                  }
                  this.$nextTick(() => {
                    this.scrollEvent()
                  });

                  if (this.$route.query.shareId) {
                    //神策埋点
                    let _this = this;
                    window.uleStatUtil &&
                      window.uleStatUtil.sendSensorTrack("ylxd_ShareClickSuccess", {
                        ylyx_shared_identify_key: "storeid", // 被分享用户  ID-key
                        ylyx_shared_identify_value: _this.$route.query.storeid || _this.$route.query.store_id || "", // 被分享用户 ID-value
                        // exp_id: exp_id,
                        ylyx_share_channel: "微信好友", // 分享渠道
                        ylyx_share_content_type: "接龙", // 分享内容类型
                        ylyx_share_content_name: _this.shareName, // 分享内容名称
                        item_id: activityId, // 物品id
                        ylxd_share_content_id: _this.$route.query.shareId, // 分享内容 ID
                      });
                  }
                  setTimeout(() => {
                    // 跳转至查看商品列表处
                    if (this.isCheck == "1") {
                      this.$nextTick(() => {
                        setTimeout(() => {
                          document.querySelector(".chains-list").scrollIntoView({
                            behavior: "smooth",
                          });
                        }, 100);
                      });
                    }
                  }, 500);
                } else {
                  this.noData = true;
                }
              } else {
                this.$toast.clear();
                this.noData = true;
              }
            } else {
              this.$toast.clear();
              this.$router.push("/others/pageList");
            }
          })
          .then(() => {
            let isQuery = true; //是否请求查券接口
            if (this.$route.params.activityId == "z178656" || this.$route.params.activityId == "z279452") {
              //z178656 邮政集团乡村振兴团购会（快递）   z279452 邮政集团乡村振兴团购会（自提）
              isQuery = false;
            }
            // 活动未结束-查询优惠券
            if (!this.isOver && isQuery) {
              // 查询优惠券
              let itemIdString = "";
              this.chainsList.forEach((item) => {
                itemIdString += `${item.itemId}:${item.categoryIdPath};`;
              });
              // 去掉最后一个分号
              itemIdString = itemIdString.slice(0, itemIdString.length - 1);
              let query = {
                itemList: itemIdString,
                businessType: "4",
                // userId: this.getStorage("user", "user.STORE_ID") || '',
                pageIndex: 1,
                pageSize: 100,
              };
              if (this.zdAct.includes(this.$route.params.activityId)) {
                console.log('不请求优惠券');
              } else {
                batchQueryCanReceiveCouponApi(query).then((res) => {
                  let data = {};
                  if (res.code == "0000") {
                    data = res.data;
                    if (data.length > 0) {
                      data.map((item) => {
                        let newObj = {
                          available: 1,
                          id: "", //优惠券 id
                          name: "", // 优惠券名称
                          condition: "", // 满减条件
                          description: "",
                          reason: "", // 不可用原因
                          value: null, // 折扣券优惠金额，单位分
                          startAt: null,
                          endAt: null,
                          valueDesc: "", // 折扣券优惠金额文案
                          unitDesc: "元", // 单位文案
                        };
                        switch (item.couponType) {
                          case "1":
                            item.type = "店铺券";
                            break;
                          case "2":
                            item.type = "商品券";
                            break;
                          case "3":
                            item.type = "运费券";
                            break;
                          case "4":
                            item.type = "充值券";
                            break;
                          case "5":
                            item.type = "通用券";
                            break;
                          case "6":
                            item.type = "品类券";
                            break;
                          case "7":
                            item.type = "跨店券";
                            break;
                          default:
                            item.type = "商品券";
                        }
                        if (item.isMultiStore == "true") {
                          item.type = "跨店券";
                        }
                        newObj.id = item.batchId;
                        newObj.name = item.remark || "优惠券名称";
                        newObj.description = item.type;
                        newObj.reason = "";
                        newObj.value = item.amount * 100;
                        newObj.startAt = this.$moment(item.expireBeginDate).format("X");
                        newObj.endAt = this.$moment(item.expireEndDate).format("X");
                        newObj.valueDesc = item.amount;
                        newObj.couponWallFlag = item.couponWallFlag;
                        item.couponName = item.type;
                        if (item.couponType == "7") {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          // newObj.condition = "全站满" + item.fullCutAmount + "减" + item.amount;
                          // item.desc = "全站满" + item.fullCutAmount + "减" + item.amount;
                        } else {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                        }
                        // arr.push(newObj);
                      });
                      this.oldCouObj = data;
                      this.isShowCouponPop = true;
                    } else {
                      this.isShowCouponPop = false;
                    }
                  } else {
                    this.isShowCouponPop = false;
                  }
                });
                let themeCode = "159523003875223";
                let userOnlyId = this.getStorage("user", "user.STORE_ID");
                let data = {
                  activityCode: "",
                  channel: "610003",
                  fieldId: "",
                  deviceId: "",
                  userOnlyId,
                };
                if (process.env.NODE_ENV === "development") {
                  themeCode = "159471246591743";
                } else if (process.env.NODE_ENV === "testing") {
                  themeCode = "159521105177522";
                } else if (process.env.NODE_ENV === "production") {
                  themeCode = "159523003875223";
                }
                // 是否登录
                if (userOnlyId) {
                  // 是否有场次
                  getActivityInfos(themeCode).then((dt) => {
                    if (dt.code === "0000") {
                      data.activityCode = dt.content[0].activityCode;
                      if (this.client_type === "miniwx_ylxdsq") {
                        data.channel = "610001";
                      }
                      lottry(data).then((rs) => {
                        if (rs.code === "0000") {
                          if (rs.content.prizeInfos.length > 0) {
                            this.isShowCoupon = true;
                            this.couponList = rs.content.prizeInfos;
                          }
                        } else {
                          this.isShowCoupon = false;
                        }
                      });
                    }
                  });
                }

              }
            } else {
              this.isShowCouponPop = false;
            }
          });
      }
    },
    // 图片点击弹层
    showImgPop(item) {
      this.currentPopImg = item.imgLarge;
      this.isShowItemImg = true;
    },
    // 获取接龙活动订单列表
    getOrderList() {
      this.query.activityCode = this.$route.params.activityId;
      // if (this.query.activityCode.indexOf("p3") > -1 || this.query.activityCode.indexOf("z3") > -1) {
        this.query.shareUserId = this.$route.query.storeid;
      // }
      getPurchaseRecord(this.query).then((res) => {
        this.loading = false;
        this.finished = false;
        if (res.returnCode === "0000" || res.code == "0000") {
          if (!res.data) {
            this.finished = true;
            this.finishedText = "";
          } else {
            this.totalCount = res.data.totalCount;
            this.orderList = res.data.activityPurchaseRecordList;
            if (this.query.pageSize >= res.data.totalCount) {
              this.finished = true;
              this.finishedText = "";
            } else {
              this.query.pageSize += 10;
              this.finished = false;
            }
          }
        } else {
          this.finished = true;
        }
        // this.orderList = res.data.activityPurchaseRecordList;
      });
    },
    // 视频播放
    play() {
      this.$refs.video.playVideo();
    },
    // 获取视频宽度
    resizeEvent() {
      this.videoWith = this.$el.clientWidth;
    },
    // 获取滚动数据
    scrollEvent() {
      try {
        // let ch = document.documentElement.clientHeight;
        // let sclh = document.documentElement.scrollTop;
        // let conH = this.$refs.contentCon.clientHeight;
        // let headH = (this.$refs.head && this.$refs.head.$el.clientHeight) || 0;
        // if (conH + headH - sclh <= ch) {
        //   this.isFixed = false;
        // } else if (ch < conH + headH) {
        //   this.isFixed = true;
        // }
        let listId = this.$route.query.listId 
        if (listId) {
          let chainLOft = this.$refs.chainsList.offsetTop;
          let sss = document.getElementById(`item${listId}`)
          // let index = sss.getAttribute('data-index')
          // this.handlePopDetail(this.chainsList[index],index)
          window.scrollTo({
            top: chainLOft + sss.offsetTop,
            behavior: "smooth",
          });
        }          
      } catch (error) {}
    },
    // 套餐数量输入过滤
    setMealFormatter() {
      let number = this.setMealNum;
      if (number === "") {
        this.setMealNum = 0;
      } else {
        // 第一位输入0
        if (number.indexOf(0) === 0) {
          console.log("number", number);
          this.setMealNum = number.replace(/0/g, "");
        }
      }
    },
    // 输入过滤
    formatter(index) {
      let number = this.chainsList[index].number;
      if (number === "") {
        this.chainsList[index].number = 0;
      } else {
        // 第一位输入0
        if (number.indexOf(0) === 0) {
          console.log("number", number);
          this.chainsList[index].number = number.replace(/0/g, "");
        }
      }
    },
    // 失去焦点
    goodsNum(item) {
      if (item.number > 0 && item.number < item.limitNum) {
        item.number = item.limitNum;
      }
    },
    // 加号
    plusClick(index) {
      if (this.chainsList[index].number < this.chainsList[index].limitNum) {
        this.chainsList[index].number = this.chainsList[index].limitNum;
      } else this.chainsList[index].number++;
    },
    // 套餐加号
    setMealPlusClick() {
      this.setMealNum++;
    },
    // 减号
    reduceClick(index) {
      if (this.chainsList[index].number <= 0) {
        return;
      } else {
        if (this.chainsList[index].number <= this.chainsList[index].limitNum) {
          this.chainsList[index].number = 0;
        } else this.chainsList[index].number--;
      }
    },
    // 套餐减号
    setMealReduceClick() {
      if (this.setMealNum === 0) {
        return;
      } else {
        this.setMealNum--;
      }
    },
    // 提交订单
    submit() {
      console.log(this.client_type);
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "提交中...",
      });
      this.subList = [];
      this.chainsList.forEach((item) => {
        if (item.number > 0) {
          this.subList.push(item.itemId + ":" + item.listId + ":" + item.number + ":" + item.salPrice);
        }
      });
      this.subList = this.subList.toString();
      if (this.$browser().miniprogram) {
        document.cookie = `store_id=${this.store_id};domain=.${this.$uleUrl()};path=/;expires=3600`;
      } else {
        document.cookie = `store_id=${this.store_id};domain=.ule.com;path=/;`;
      }

      setTimeout(() => {
        this.$toast.clear();
        this.$refs.orderForm.submit();
      }, 300);
    },
    appGetPioltFlag() {
      dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      dsBridge.register("getPilotStatusResult", (s) => {
        if (typeof s == "string") {
          s = JSON.parse(s);
        }
        if (s) {
          this.freshActType = "1";
          document.cookie = `ispioltCity=1;domain=.${this.$uleUrl()};path=/;expires=3600`;
        }
        this.shareActivity();
      });
    },
    // 分享
    share() {
      // 邮乐生鲜APP
      if (this.$browser().ylxdsq || this.$browser().ulemax) {
        if (this.$browser().ios && this.$browser().version >= 244) {
          this.appGetPioltFlag();
        } else if (this.$browser().android && this.$browser().version >= 242) {
          this.appGetPioltFlag();
        } else {
          this.shareActivity();
        }
      } else if (this.isHnApp) {
        this.hnShare();
      } else if (this.$browser().zyet) {
        // 中邮易自提
        this.zyShare();
      }
      // 邮鲜小程序
      else if (this.$browser().miniprogram) {
        this.shareMiniprogram(`您的好友邀请您参与接龙：${this.shareName}`, `您的好友邀请您参与接龙：${this.shareName}`, location.href, this.videoImg, this.$route.params.activityId, 0, 0);
      }
      // 企业微信
      else if (this.$browser().wxwork) {
        // 获取分享id
        let data = {
          shareChannel: "8",
          client_type: "",
          shareName: "邮乐优鲜",
          clientCallType: "H5",
          shareType: "86",
          shareLink: `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`,
          unionRef: this.$route.params.activityId,
        };
        getShareURL(data, "jsoncallback").then((res) => {
          if (res.returnCode === "0000") {
            this.$toast.clear();
            let shareObj = {};
            try {
              shareObj = {
                shareTitle: `您的好友邀请您参与接龙：${this.shareName}`,
                shareContent: `您的好友邀请您参与接龙：${this.shareName}`,
                listImage: this.videoImg || this.chainsList[0].imgUrl,
                url: `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`,
              };
            } catch (e) {}
            let marketerId = (this.$cookies.get("ul_union") || "").split("|")[2];
            let userOnlyId = this.getStorage("user", "user.STORE_ID");
            shareObj.url = `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}?storeid=${userOnlyId}&shareId=${
              res.data.shareId
            }&adid=bsc_qiyewx_fresh_share&ul_union=${this.$cookies.get("ul_union")}`;
            getShareInfo(shareObj, marketerId);
          } else {
            console.log("分享参数查询失败");
          }
        });
        //微信
      } else if (this.$browser().wx) {
        this.shareWx(`您的好友邀请您参与接龙：${this.shareName}`, `您的好友邀请您参与接龙：${this.shareName}`, location.href, this.videoImg || this.chainsList[0].imgUrl);
      } else {
        this.$toast("点击浏览器分享");
      }
    },
    // APP分享
    shareActivity() {
      let data = {
        shareName: this.shareName,
        clientCallType: "H5",
        shareType: 59,
        shareLink: `https://h5.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`,
        unionRef: this.$route.params.activityId,
      };
      if (this.freshActType) {
        data.shareLink = data.shareLink + "?freshActType=" + this.freshActType;
      }
      getShareURL(data).then((res) => {
        let shareData = res.data;
        let data = {
          listName: this.shareName,
          listImage: [this.videoImg],
          shareCommission: 0,
          shareTitle: `${this.shareName}`,
          shareContent: `${this.shareName}`,
          WXMiniProgram_Type: 0, // 0正式版，1测试版 2体验版
          WXMiniProgram_DialogName: "微信好友",
          WXMiniProgram_userName: "gh_1e6276474cf7",
          WXMiniProgram_Title: `${this.shareName}`,
          WXMiniProgram_pageUrl: shareData.shareUrl3,
          // WXMiniProgram_path: `packageA/solitaire/index?activityCode=${this.$route.params.activityId}`,
          WXMiniProgram_path: "pages/index/index?targetUrl=" + encodeURIComponent(shareData.shareUrl3),
          WXMiniProgram_OriginalId: "gh_1e6276474cf7",
          // WXMiniProgram_path: shareData.miniWxShareInfo && shareData.miniWxShareInfo.path,
          // WXMiniProgram_OriginalId: shareData.miniWxShareInfo && shareData.miniWxShareInfo.originalId,
          WXMiniProgram_image: this.videoImg,

          canShareOkCallBack: true,
          ruleDescription: "",
          imageBanner: this.videoImg,
        };
        let shareObj = this.objectassign({}, data, shareData, {
          listId: this.$route.params.activityId,
          sharePrice: 0,
          marketPrice: 0,
          shareFrom: "0",
        });
        shareObj.shareOptions = "4##1";
        if (this.$browser().ylxdsq || this.$browser().ulemax) {
          shareObj.shareUrl = shareObj.shareUrl4 || shareObj.shareUrl3;
        }
        if (window.dsBridge) {
          window.dsBridge.call("generalAction", {
            type: "2",
            ios_action: JSON.stringify(shareObj),
            android_action: JSON.stringify(shareObj),
            maxversion: "999&999",
            needlogin: "false",
          });
        } else {
          window.location.href =
            "uleMobile://uleShare_" + encodeURI(shareObj.shareTitle) + "##" + encodeURI(shareObj.shareContent) + "##" + shareObj.listImage + "##" + shareObj.shareUrl + "##" + shareObj.shareContent;
        }
      });
    },
    // 中邮易自提 暂时没有中邮app内分享
    async zyShare() {
      const shareName = `您的好友邀请您参与接龙~：${this.shareName}`;
      const shareImg = this.videoImg || this.chainsList[0].imgUrl;
      const shareUrl = `https://h5.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`;
      let data = {
        //中邮接口请求参数
        shareChannel: "9",
        client_type: "app_zyet",
        shareName: "社区团购",
        clientCallType: "H5",
        shareType: "92",
        shareLink: shareUrl,
      };
      const xhr = await this.getShareURL(data);
      if (!xhr) return;
      let zyShare = {
        // 中邮分享参数
        name: shareName,
        picUrl: shareImg,
        qrcode: xhr.shareUrl4,
      };
      console.log(window.myObj, zyShare, "中邮自提");
      if (window.dsBridge && typeof window.dsBridge === "object") {
        console.log("进入分享方法");
        window.dsBridge.call("myObj.ShareUleEvents", JSON.stringify(zyShare));
      }
    },
    // 惠农APP分享
    async hnShare() {
      const shareName = `您的好友邀请您参与接龙~：${this.shareName}`;
      const shareImg = this.videoImg || this.chainsList[0].imgUrl;
      const shareUrl = `https://h5.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`;
      let data = {
        // 惠农接口请求参数
        shareChannel: "6",
        client_type: "app_huinong",
        shareName: "社区团购",
        clientCallType: "H5",
        shareType: "59",
        shareLink: shareUrl,
      };
      const xhr = await this.getShareURL(data);
      if (!xhr) return;
      let hnShare = {
        num: 2,
        to: "session",
        title: "社区团购",
        content: shareName,
        image: shareImg,
        url: xhr.url,
      };
      console.log(hnShare, "惠农分享");
      this.$postingApp.shareLink(JSON.stringify(hnShare), (r) => {
        console.log("这里是分享回调方法", r);
        callback(r);
      });
    },
    // 分享获取参数
    async getShareURL(data) {
      const xhr = await getShareURL(data, "jsoncallback");
      if (xhr.returnCode === "0000") {
        this.$toast.clear();
        return xhr.data;
      } else {
        console.log("分享参数查询失败");
      }
    },
    downChange(e) {
      if (e.hours < 10) {
        e.hours = `0${e.hours}`;
      }
      if (e.minutes < 10) {
        e.minutes = `0${e.minutes}`;
      }
      if (e.seconds < 10) {
        e.seconds = `0${e.seconds}`;
      }
    },
    // 接龙结束
    activelFinish() {
      this.isOver = true;
    },
    // 锚点跳转
    goAnchor(id) {
      if (this.shopNumber < 10) {
        var anchor = `.${id}`;
        document.querySelector(anchor).scrollIntoView({
          behavior: "smooth",
        });
      }
    },
    // 查询人数和成单
    getNumber(params) {
      chainsInfoApi(params).then((res) => {
        if (res.code == "0000") {
          let { buyerCount, productNumTotal } = res.data;
          this.buyerCount = buyerCount;
          this.productNumTotal = productNumTotal;
        }
      });
    },
    // 更多点击
    changeMore() {
      this.showMore = !this.showMore;
      if (this.showMore) {
        this.moreText = "点击隐藏更多商品介绍";
      } else {
        this.moreText = "点击查看更多商品介绍";
      }
    },
    // 优鲜APP中获取是否试点
    callPilotStatus: function() {
      var that = this;
      window.dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      window.dsBridge.register("getPilotStatusResult", function(s) {
        that.isPilot = s;
      });
    },
    noBegin() {
      this.$toast("活动尚未开始");
    },
    handleTogglePop(res, pos) {
      if (pos == "bottom") {
        this.isShowBottom = res;
      } else if ("middle") {
        this.isShowMiddle = res;
      } else {
        this.isShowBottom = res;
      }
    },
    // 发布
    handlePublish() {
      console.log("activityId", this.activityId);
      console.log("id", this.id);
      chainsPublishApi({
        id: this.id,
        clientCallType: "H5",
      })
        .then((res) => {
          if (res.returnCode == "0000") {
            this.currentState = 2;
            window.dsBridge.call("setNativeTitle", {
              title: "拼团接龙",
            });
            this.handleTogglePop(true, "middle");
            window.dsBridge.call("groupFinish");
          } else {
            this.$toast("操作失败");
          }
        })
        .catch(() => {
          this.$toast("操作失败");
        });
    },
    // 返回修改
    handleBackEdit() {
      // window.location.href = "ulemobile://ulePopView";
      let obj = {
        activityId: this.id,
        logistics: "2",
      };
      obj = JSON.stringify(obj);
      console.log("obj", obj);
      window.dsBridge.call("editGroup", obj);
    },
    // 获取登录人信息
    getUserInfo() {
      return qryYlxdSqSelfPickupSitesApi().then((res) => {
        console.log("res=", res);
        if (res.returnCode == "0000") {
          // 有自提点
          if (res.data) {
            return 1;
          } else {
            return 2;
          }
        } else {
          return 2;
        }
      });
    },
    // 获取商品列表
    fetch() {
      this.cateQuery.activityId = this.cateActivityId;
      findXcxItemPubByConditionApi(this.cateQuery).then((res) => {
        this.cateLoading = false;
        if (res.returnCode === "0000" && res.data) {
          // 无数据
          if (res.data.result.length === 0) {
            this.cateFinished = true;
          } else {
            // 活动列表下拉load事件
            if (document.querySelector(".van-tree-select__content").scrollTop === 0) {
              setTimeout(() => {
                document.querySelector(".van-tree-select__content").scrollTo(0, 1);
              }, 10);
            }
            res.data.result.forEach((item) => {
              if (~item.imgUrl.indexOf("http://")) {
                item.imgUrl = item.imgUrl.replace("http://", "https://");
              }
              // 有自提点
              if (this.isSite == 1) {
                item.shareCommission > 0 ? (item.shareCommission = Number(item.shareCommission).toFixed(2)) : "0.00";
                item.saleCommission > 0 ? (item.saleCommission = Number(item.saleCommission).toFixed(2)) : "0.00";
              }
              // 无自提
              else if (this.isSite == 2) {
                // item.totalCommission = (Number(item.yzgRealCommission) - Number(item.saleCommission || 0)).toFixed(2);
                if (item.shareCommission > 0) {
                  item.totalCommission = item.shareCommission;
                } else {
                  item.totalCommission = item.yzgRealCommission || 0;
                }
                console.log("totalCommission==", item.totalCommission);
              }
            });
            this.cateQuery.pageIndex++;
            let totalPage = Math.floor(this.pageCount(res.data.totalRecords));
            this.cont[0]["goods"] = this.cont[0]["goods"].concat(res.data.result);
            this.cont[0]["goods"].forEach((item) => {
              this.$set(item, "number", 0);
              if (item.imgUrl) {
                item.imgUrl = item.imgUrl.split("|*|")[0];
                item.imgUrl = item.imgUrl.replace("http://", "https://");
                item.imgLarge = item.imgUrl;
                if (!/_l\.jpg/.test(item.imgUrl)) {
                  item.imgUrl = item.imgUrl.replace(".jpg", "_l.jpg");
                }
              }
            });
            this.cont[0]["goods"].filter((v) => {
              this.cateSelectList.some((val) => {
                if (val.listId == v.listId) {
                  v.number = val.number;
                }
              });
            });
            console.log("goods", this.cont[0]["goods"]);
            if (this.cateQuery.pageIndex > totalPage) {
              this.cateFinished = true;
              this.cateFinishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.cateFinished = false;
            }
          }
          let first = "",
            second = "";
          console.log("categoryIds", res.data.result[0].categoryIds);
          console.log("this.cateQuery.categoryId", this.cateQuery.categoryId);
        } else {
          this.cateFinished = true;
          this.cateFinishedText = "我已到达底部, 暂无其他数据啦~~";
        }
      });
    },
    // 左侧切换
    changeTab(index) {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cont[0]["goods"] = [];
      this.rightNavList = this.leftNavList[index].children;
      this.currentNav = this.rightNavList[0].id;
      this.cateQuery.pageIndex = 1;
      this.cateQuery.categoryId = this.currentNav;
      this.cateLoading = false;
      this.cateFinished = false;
      this.isLoad = true;
      this.setSelectedCate("categoryId", this.leftNavList[index].id);
      this.setSelectedCate("subCateId", this.currentNav);
      if (index !== 0) {
        document.querySelector(".van-tree-select__content").classList.add("left-top-radius");
        document.querySelector(".category-nav").classList.add("left-top-radius");
      } else {
        document.querySelector(".van-tree-select__content").classList.remove("left-top-radius");
        document.querySelector(".category-nav").classList.remove("left-top-radius");
      }
      window.uleStatUtil &&
        window.uleStatUtil.sendSensorTrack("navigationBarClick", {
          navigation_bar_type: "左侧",
          navigation_bar_name: this.leftNavList[index].text,
        });
      // this.fetch();
    },
    handleToserch() {
      if (this.cateQuery.itemName) {
        this.$toast.loading({
          duration: 500,
          mask: true,
          message: "加载中...",
        });
        this.cateQuery.pageIndex = 1;
        // this.cateQuery.categoryId = '';
        this.cateLoading = false;
        this.cateFinished = false;
        this.isLoad = true;
        this.cont[0]["goods"] = [];
      }
      window.uleStatUtil &&
        window.uleStatUtil.sendSensorTrack("searchButtonClick", {
          ule_title: "接龙页",
          search_type: "通用商品搜索",
          search_keyword: this.cateQuery.itemName,
          search_keyword_type: "",
        });
    },
    handleResetCate() {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cateQuery.itemName = "";
      this.cateQuery.pageIndex = 1;
      this.cateLoading = false;
      this.cateFinished = false;
      this.isLoad = true;
      this.cont[0]["goods"] = [];
    },
    // 右侧点击
    rightNavChange(item) {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cont[0]["goods"] = [];
      this.cateQuery.categoryId = item.id;
      this.currentNav = item.id;
      this.cateQuery.pageIndex = 1;
      this.cateLoading = false;
      this.cateFinished = false;
      this.isLoad = true;
      this.setSelectedCate("subCateId", this.currentNav);
      // this.fetch();
    },
    setSelectedCate(type, value) {
      this.selected[type] = value;
      // localStorage.setItem("ylxdsq.category", JSON.stringify(this.selected));
    },
    stepChangeDebounceRight: _.debounce(function(e) {
      let _this = this;
      console.log(e);
      _this.rightNavChange(e);
    }, 500),
    navChangeDebounceLeft: _.debounce(function(e) {
      let _this = this;
      console.log(e);
      _this.changeTab(e);
    }, 500),
    // 右侧箭头切换
    showMoreCategory() {
      this.categoryNavShow = !this.categoryNavShow;
    },
    // 计算总页数
    pageCount(totalCount) {
      return (totalCount + this.cateQuery.pageSize - 1) / this.cateQuery.pageSize;
    },
  },
  filters: {
    useConditions(val) {
      return val && val.replace(/\.(0|00)元/, "元");
    },
  },
};
